/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * Unique identifier for the image
     * @type {string}
     * @memberof Image
     */
    readonly id: string;
    /**
     * Full resolution image URL
     * @type {string}
     * @memberof Image
     */
    url: string;
    /**
     * Preview image URL (medium resolution)
     * @type {string}
     * @memberof Image
     */
    previewUrl: string | null;
    /**
     * Thumbnail image URL (low resolution)
     * @type {string}
     * @memberof Image
     */
    thumbnailUrl: string | null;
    /**
     * Image width in pixels
     * @type {number}
     * @memberof Image
     */
    width: number | null;
    /**
     * Image height in pixels
     * @type {number}
     * @memberof Image
     */
    height: number | null;
    /**
     * Source of the image
     * @type {string}
     * @memberof Image
     */
    source: ImageSourceEnum;
    /**
     * Attribution text for the image
     * @type {string}
     * @memberof Image
     */
    attribution: string | null;
    /**
     * Source page URL where the image was found
     * @type {string}
     * @memberof Image
     */
    sourceUrl: string | null;
    /**
     * Name of the image author/contributor
     * @type {string}
     * @memberof Image
     */
    authorName: string | null;
    /**
     * Profile URL of the image author
     * @type {string}
     * @memberof Image
     */
    authorUrl: string | null;
    /**
     * Image description or alt text
     * @type {string}
     * @memberof Image
     */
    description: string | null;
    /**
     * Original Unsplash photo ID
     * @type {string}
     * @memberof Image
     */
    unsplashId: string | null;
    /**
     * Photographer username on Unsplash
     * @type {string}
     * @memberof Image
     */
    photographerUsername: string | null;
    /**
     * Download tracking URL for Unsplash
     * @type {string}
     * @memberof Image
     */
    downloadUrl: string | null;
    /**
     * Timestamp when the image was created
     * @type {Date}
     * @memberof Image
     */
    readonly createdAt: Date;
    /**
     * Timestamp when the image was last updated
     * @type {Date}
     * @memberof Image
     */
    readonly updatedAt: Date;
}


/**
 * @export
 */
export const ImageSourceEnum = {
    Unsplash: 'unsplash',
    Google: 'google',
    Manual: 'manual'
} as const;
export type ImageSourceEnum = typeof ImageSourceEnum[keyof typeof ImageSourceEnum];


/**
 * Check if a given object implements the Image interface.
 */
export function instanceOfImage(value: object): value is Image {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('previewUrl' in value) || value['previewUrl'] === undefined) return false;
    if (!('thumbnailUrl' in value) || value['thumbnailUrl'] === undefined) return false;
    if (!('width' in value) || value['width'] === undefined) return false;
    if (!('height' in value) || value['height'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('attribution' in value) || value['attribution'] === undefined) return false;
    if (!('sourceUrl' in value) || value['sourceUrl'] === undefined) return false;
    if (!('authorName' in value) || value['authorName'] === undefined) return false;
    if (!('authorUrl' in value) || value['authorUrl'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('unsplashId' in value) || value['unsplashId'] === undefined) return false;
    if (!('photographerUsername' in value) || value['photographerUsername'] === undefined) return false;
    if (!('downloadUrl' in value) || value['downloadUrl'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ImageFromJSON(json: any): Image {
    return ImageFromJSONTyped(json, false);
}

export function ImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Image {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'url': json['url'],
        'previewUrl': json['previewUrl'],
        'thumbnailUrl': json['thumbnailUrl'],
        'width': json['width'],
        'height': json['height'],
        'source': json['source'],
        'attribution': json['attribution'],
        'sourceUrl': json['sourceUrl'],
        'authorName': json['authorName'],
        'authorUrl': json['authorUrl'],
        'description': json['description'],
        'unsplashId': json['unsplashId'],
        'photographerUsername': json['photographerUsername'],
        'downloadUrl': json['downloadUrl'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

  export function ImageToJSON(json: any): Image {
      return ImageToJSONTyped(json, false);
  }

  export function ImageToJSONTyped(value?: Omit<Image, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'previewUrl': value['previewUrl'],
        'thumbnailUrl': value['thumbnailUrl'],
        'width': value['width'],
        'height': value['height'],
        'source': value['source'],
        'attribution': value['attribution'],
        'sourceUrl': value['sourceUrl'],
        'authorName': value['authorName'],
        'authorUrl': value['authorUrl'],
        'description': value['description'],
        'unsplashId': value['unsplashId'],
        'photographerUsername': value['photographerUsername'],
        'downloadUrl': value['downloadUrl'],
    };
}

